import { ReservationOccasion } from '../../../../../services/exports/Constants';

export default {
  updated_details: 'Detalhes Atualizados',
  previous_details: 'Detalhes Anteriores',
  fields: {
    datetime: 'Data:',
    email: 'Email:',
    phone_number: 'Número de telefone:',
    customer: 'Cliente:',
    source: 'Origem:',
    guests: 'Convidados:',
    comment: 'Comentário:',
    confirmed_at: 'Confirmado Em:',
    status: 'Estado:',
    occasion: 'Ocasião:',
    created_at: 'Criado em:',
  },
  status: {
    confirmed: 'Confirmado',
    pending: 'A aguardar aprovação',
    canceled: 'Cancelado',
    canceled_by_customer: 'Cancelado pelo cliente',
    rejected: 'Rejeitado',
    removed: 'Removido',
  },
  buttons: {
    confirm: 'Confirmar',
    reject: 'Rejeitar',
    cancel: 'Cancelar',
    edit: 'Editar',
    remove: 'Remover',
  },
  occasion: {
    [ReservationOccasion.Birthday]: 'Aniversário',
    [ReservationOccasion.Anniversary]: 'Aniversário de casamento',
    [ReservationOccasion.Date]: 'Encontro',
    [ReservationOccasion.SpecialOccasion]: 'Ocasião Especial',
    [ReservationOccasion.BusinessMeal]: 'Refeição de Negócios',
  },
  remove_reservation_modal: {
    title: 'Tem a certeza de que pretende remover a reserva?',
    buttons: {
      remove: 'Remover',
      cancel: 'Cancelar',
    },
  },
  response_messages: {
    success: 'Estado da reserva atualizado com sucesso. O cliente foi notificado.',
    error: 'Falha ao atualizar o estado da reserva. Por favor, tente novamente.',
  },
};
